module.exports = __webpack_public_path__ + "media/images/icons/country_flags/so-178fe49679297c70c6b7d6002fda3caa.svg";